import React, { FC } from 'react'

export const Heading: FC = ({ children }) => {
  return (
    <h2 className="h5 font-weight-bold mb-3 text-center">
      {children}
    </h2>
  )
};
